import { render, staticRenderFns } from "./WarningDialog.vue?vue&type=template&id=2ba07d45&"
import script from "./WarningDialog.vue?vue&type=script&lang=js&"
export * from "./WarningDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports